export const gravity = 9;
export const bgc = '#211e20';
export const bgc2 = '#555568';
export const fgc = '#a0a08b';
export const fgc2 = '#e9efec';
export const acc = '#e20fa0';

export const RESTING_DISTANCE = 7;
